<!-- @if (ready === true) { -->
<div [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<!-- } -->
